import {
	AppBar,
	Dialog,
	Menu,
	MenuItem,
	Slide,
	Toolbar,
	Typography,
	WithStyles,
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Column } from 'react-table';
import { Dispatch } from 'redux';
import { Routes, Screens } from 'src/utils/Routes';
import * as Actions from '../actions/skill';
import ReactTable, {
	RowInfo,
	RowRenderProps,
} from '../components/MyReactTable';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import SkillMapDetail from './SkillMapDetail';
const ITEM_HEIGHT = 48;

const styles = ({ spacing }: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		certer: {
			textAlign: 'center',
		},
		detailDialog: {
			width: '80%',
		},
		innerButton: {
			fontSize: '0.625rem',
			marginLeft: spacing(1),
			marginRight: spacing(1),
			minWidth: 48,
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		mapDialog: {
			width: '80%',
		},
		menuButton: {
			height: '32px',
			width: '32px',
		},
		pointer: {
			cursor: 'pointer',
		},
		rowBlue: {
			'&:hover': {
				backgroundColor: '#CEDDFF !important',
			},
			backgroundColor: '#D9E5Ff !important',
		},
		rowGray: {
			'&:hover': {
				backgroundColor: '#E5E5E5 !important',
			},
			backgroundColor: '#EEEEEE !important',
		},
		rowOrange: {
			'&:hover': {
				backgroundColor: '#FFEFBC !important',
			},
			backgroundColor: '#FFF4D1 !important',
		},
		rowPink: {
			'&:hover': {
				backgroundColor: '#FFD6DA !important',
			},
			backgroundColor: '#FFE1E4 !important',
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
	});

export enum SkillTableTypes {
	ONGOING,
	RESULT,
}

interface IState {
	functionMenus?: JSX.Element;
	selectColumnsMenuAnchorEl?: HTMLElement;
	openSkillMapDetailDialog: boolean;
	skillMapId: string;
}

class ISkillMapTable extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			openSkillMapDetailDialog: false,
			selectColumnsMenuAnchorEl: undefined,
			skillMapId: '',
		};
	}
	public componentWillUpdate(nextProps: IProps) {
		if (this.props.data !== nextProps.data) {
			return true;
		}
		return false;
	}

	public render() {
		const { classes } = this.props;
		const columns = this.getSelectedColumns();

		return (
			<>
				<ReactTable
					data={this.props.data}
					columns={columns}
					defaultPageSize={5}
					className="-striped -highlight"
					getTrProps={this.setRowColor(classes)}
					getTdProps={this.setColumn(classes)}
					columnsMenu={true}
					menuHandler={this.handleSelectColumns}
				/>
				{this.state.selectColumnsMenuAnchorEl &&
					this.getSelectColumnsMenu()}
				{this.state.functionMenus}
				<Dialog
					fullScreen={false}
					TransitionComponent={Transition}
					open={this.state.openSkillMapDetailDialog}
					onClose={this.handleCloseSkillDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: classes.detailDialog,
						scrollPaper: classes.scrollPaper,
					}}
				>
					<AppBar className={classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handleCloseSkillDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('SkillMapTable_0001')}
							</Typography>
						</Toolbar>
					</AppBar>
					<SkillMapDetail skillMapId={this.state.skillMapId} />
				</Dialog>
			</>
		);
	}

	/**
	 * 全列情報取得
	 */
	protected getAllColumns(): any[] {
		const { classes } = this.props;
		if (this.props.type === SkillTableTypes.ONGOING) {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Header: i18n.t('SkillMapTable_0002'),
					accessor: 'compulsoryID',
					show: false,
					width: 120,
				},
				{
					Header: i18n.t('SkillMapTable_0003'),
					accessor: 'careerSubTitle',
					show: false,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.handleOpenSkillDetailDialog(
									row.original.cmid
								)}
							>
								{row.original.cmtitle}
							</span>
						);
					},
					Header: i18n.t('SkillMapTable_0004'),
					accessor: 'cmtitle',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('SkillMapTable_0005'),
					accessor: 'organizer',
					show: false,
				},
				{
					Header: i18n.t('SkillMapTable_0006'),
					accessor: 'updateUserIDName',
					show: false,
					width: 300,
				},
				{
					Header: i18n.t('SkillMapTable_0007'),
					accessor: 'updateDate',
					show: false,
					width: 300,
				},
			];
		} else {
			return [
				{
					Cell: (row: RowRenderProps) => {
						return (
							<IconButton
								aria-label="More"
								aria-owns={
									this.state.functionMenus
										? 'long-menu'
										: undefined
								}
								aria-haspopup="true"
								data-index={row.index}
								onClick={this.handleOpenMenu}
								className={classes.menuButton}
								size="small"
							>
								<MenuIcon />
							</IconButton>
						);
					},
					accessor: 'function',
					required: true,
					show: false,
					sortable: false,
					width: 40,
				},
				{
					Header: i18n.t('SkillMapTable_0002'),
					accessor: 'compulsoryID',
					show: false,
					width: 120,
				},
				{
					Header: i18n.t('SkillMapTable_0003'),
					accessor: 'careerSubTitle',
					show: false,
					width: 120,
				},
				{
					Cell: (row: RowRenderProps) => {
						return (
							<span
								className={this.props.classes.link}
								onClick={this.handleOpenSkillDetailDialog(
									row.original.cmid
								)}
							>
								{row.original.cmtitle}
							</span>
						);
					},
					Header: i18n.t('SkillMapTable_0004'),
					accessor: 'cmtitle',
					show: false,
				},
				{
					Header: i18n.t('SkillMapTable_0005'),
					accessor: 'organizer',
					show: false,
				},
				{
					Header: i18n.t('SkillMapTable_0008'),
					accessor: 'applyEndTime',
					show: false,
				},
			];
		}
	}

	/**
	 * 選択中列情報取得
	 */
	protected getSelectedColumns() {
		const columns: any[] = Object.assign([], this.getAllColumns());

		columns.map((column: any) => {
			if (column.required) {
				column.show = true;
			} else {
				column.show = false;
			}
		});

		this.props.selectedColumns.map((index: number) => {
			columns[index].show = true;
		});

		return columns;
	}

	/**
	 * 列選択メニュー取得
	 */
	protected getSelectColumnsMenu() {
		const { classes } = this.props;
		const allColumns = this.getAllColumns();
		const checkboxList: any[] = [];
		allColumns.map((column: any, index: number) => {
			if (!column.required) {
				checkboxList.push({
					checked: this.props.selectedColumns.indexOf(index) !== -1,
					index,
					text: column.Header,
				});
			}
		}, this);

		return (
			<Menu
				id="logout-menu"
				anchorEl={this.state.selectColumnsMenuAnchorEl}
				open={this.state.selectColumnsMenuAnchorEl ? true : false}
				onClose={this.handleCloseSelectColumns}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
			>
				{checkboxList.map((checkboxItem, i) => {
					return (
						<MenuItem key={i}>
							<Checkbox
								id={checkboxItem.text}
								onChange={this.handleChangeCheckBox(
									checkboxItem
								)}
								checked={checkboxItem.checked}
							/>
							<InputLabel
								className={classes.pointer}
								htmlFor={checkboxItem.text}
							>
								{checkboxItem.text}
							</InputLabel>
						</MenuItem>
					);
				})}
			</Menu>
		);
	}

	/**
	 * 行メニュー取得
	 * @param functionMenuAnchorEl アンカー要素
	 * @param rowData 行情報
	 */
	protected getFunctionMenus(
		functionMenuAnchorEl: HTMLElement,
		rowData: Actions.IOnGoingSkillMap | Actions.IResultSkillMap
	) {
		return (
			<Menu
				anchorEl={functionMenuAnchorEl}
				open={true}
				onClose={this.handleCloseMenu}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				transformOrigin={{ vertical: 'top', horizontal: 'center' }}
				getContentAnchorEl={undefined}
				PaperProps={{
					style: {
						maxHeight: ITEM_HEIGHT * 4.5,
						width: 200,
					},
				}}
			>
				<MenuItem onClick={this.showDetail(rowData)}>
					{i18n.t('SkillMapTable_0009')}
				</MenuItem>
				<MenuItem onClick={this.showMapDetail(rowData)}>
					{i18n.t('SkillMapTable_0010')}
				</MenuItem>
				<MenuItem onClick={this.showProcessStatus(rowData)}>
					{i18n.t('SkillMapTable_0011')}
				</MenuItem>
			</Menu>
		);
	}

	/**
	 * マップ表示
	 */
	protected showMapDetail = (
		rowData: Actions.IOnGoingSkillMap | Actions.IResultSkillMap
	) => () => {
		let to = Routes.getPath(Screens.PERSONAL_SKILL_MAP);
		to = to.replace(/\/:cmid/, `/${rowData.cmid}`);
		this.props.pushHistory(to);
	};

	/**
	 * 進捗状況表示
	 */
	protected showProcessStatus = (
		rowData: Actions.IOnGoingSkillMap | Actions.IResultSkillMap
	) => () => {
		let to = Routes.getPath(Screens.PERSONAL_PROCESS_STATUS);
		to = to.replace(/\/:skill_map_id/, `/${rowData.cmid}`);
		this.props.pushHistory(to);
	};

	/**
	 * 詳細情報表示
	 */
	protected showDetail = (
		rowData: Actions.IOnGoingSkillMap | Actions.IResultSkillMap
	) => () => {
		let to = Routes.getPath(Screens.PERSONAL_SKILL_MAP_DETAIL);
		to = to.replace(/\/:skill_map_id/, `/${rowData.cmid}`);
		this.props.pushHistory(to);
	};

	/**
	 * スキルマップ詳細情報画面閉じるハンドラ
	 */
	protected handleCloseSkillDetailDialog = () => {
		this.setState({ skillMapId: '', openSkillMapDetailDialog: false });
	};

	protected handleOpenSkillDetailDialog = (cmid: string) => () => {
		this.setState({ skillMapId: cmid, openSkillMapDetailDialog: true });
	};

	/**
	 * 行カラー設定
	 */
	protected setRowColor = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo
	) => {
		if (rowInfo === undefined) {
			return {};
		}
		let className: string = '';
		if (rowInfo.original.compulsoryCssClass === 'row_color_pink') {
			className = classes.rowPink;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_orange') {
			className = classes.rowOrange;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_blue') {
			className = classes.rowBlue;
		} else if (rowInfo.original.compulsoryCssClass === 'row_color_gray') {
			className = classes.rowGray;
		}

		return {
			className,
		};
	};

	/**
	 * 列設定
	 */
	protected setColumn = (classes: Record<string, string>) => (
		state: any,
		rowInfo: RowInfo,
		column?: Column
	) => {
		if (column === undefined) {
			return {};
		}
		let className: string = '';
		if (column.id === 'updateDate' || column.id === 'applyEndTime') {
			className = classes.certer;
		}
		return {
			className,
		};
	};

	/**
	 * メニューオープンハンドラ
	 */
	protected handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
		const index = event.currentTarget.getAttribute('data-index');
		if (index && index !== '') {
			if (this.props.type === SkillTableTypes.ONGOING) {
				const rowData: Actions.IOnGoingSkillMap = this.props.data[
					index
				];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			} else if (this.props.type === SkillTableTypes.RESULT) {
				const rowData: Actions.IResultSkillMap = this.props.data[index];
				const functionMenus = this.getFunctionMenus(
					event.currentTarget,
					rowData
				);
				this.setState({ functionMenus });
			}
		}
	};

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = () => {
		this.setState({ functionMenus: undefined });
	};

	/**
	 * 列選択メニューハンドラ
	 */
	protected handleSelectColumns = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({
			selectColumnsMenuAnchorEl: event.currentTarget,
		});
	};

	/**
	 * 列選択メニュークローズハンドラ
	 */
	protected handleCloseSelectColumns = () => {
		this.setState({
			selectColumnsMenuAnchorEl: undefined,
		});
	};

	/**
	 * チェックボックス変更ハンドラ
	 */
	protected handleChangeCheckBox = (checkboxItem: any) => (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const newSelectedColumns = Object.assign(
			[],
			this.props.selectedColumns
		);
		const idx = newSelectedColumns.indexOf(checkboxItem.index);

		if (event.target.checked) {
			if (idx === -1) {
				newSelectedColumns.push(checkboxItem.index);
			}
		} else {
			if (idx !== -1) {
				newSelectedColumns.splice(idx, 1);
			}
		}

		if (this.props.type === SkillTableTypes.ONGOING) {
			this.props.setOnGoingSelectedColumns(newSelectedColumns);
		} else if (this.props.type === SkillTableTypes.RESULT) {
			this.props.setResultSelectedColumns(newSelectedColumns);
		}
	};
}

const Transition: React.FC<any> = props => {
	return <Slide direction="up" {...props} />;
};

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setOnGoingSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setOnGoingSkillMapSelectedColumns({
				selectedColumns,
			})
		),
	setResultSelectedColumns: (selectedColumns: number[]) =>
		dispatch(
			Actions.setResultSkillMapSelectedColumns({
				selectedColumns,
			})
		),
});

interface ISkillMapTableProps {
	data: Actions.IOnGoingSkillMap[] | Actions.IResultSkillMap[];
	selectedColumns: number[];
	type: SkillTableTypes;
	userId: string;
	adminView: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ISkillMapTableProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ISkillMapTable);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/SkillMapTable.tsx